module.exports = __webpack_public_path__ + "img/logorn.6215f123.png";